angular.module('constants', [])
    //if this value is changed, change in nginx config too.
    .constant('maxUpload', '20MB');
